import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "api/src/server";

export const trpc = createTRPCReact<AppRouter>();
